function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgFlagCa = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 32",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "#fff",
    d: "M0 32h40V0H0z"
  }), ___EmotionJSX("path", {
    fill: "#be1e2d",
    d: "M30.4 32V0H40v32h-9.6zM0 32V0h9.6v32H0zM19.991 6.4l1.536 2.864c.174.311.486.282.799.109l1.112-.576-.829 4.399c-.174.804.385.804.661.456l1.94-2.172.315 1.103c.036.145.196.297.436.261l2.453-.516-.644 2.343c-.138.521-.246.737.139.875l.874.411-4.223 3.43a.553.553 0 00-.192.575l.37 1.213c-1.454-.168-2.757-.42-4.212-.575-.128-.014-.323.208-.323.357l.111 4.434h-.707l.193-4.444c.001-.149-.214-.361-.343-.347-1.455.155-2.758.407-4.212.575l.37-1.213a.555.555 0 00-.192-.575l-4.223-3.43.874-.411c.385-.137.277-.353.139-.875l-.644-2.343 2.453.516c.24.036.399-.116.436-.261l.315-1.103 1.94 2.172c.276.348.835.348.661-.456l-.829-4.399 1.112.576c.312.174.624.203.799-.109L19.992 6.4z"
  }), ___EmotionJSX("path", {
    fill: "#2d2926",
    opacity: 0.15,
    d: "M38 30H2V2h36v28zm2-30H0v32h40V0z"
  }));
});
export default SvgFlagCa;